import React from 'react';
import { Button, PaperIcon, Typography } from '@nackle/paper';
import { getString } from '@nackle/intl-tools';
import { COURSE } from '../../const';
import './styles.less';

const CourseCarouseItem = ({
  item,
  buttonSize = 'middle',
  buttonShape = 'rectangle',
  showCompleteIcon = true,
  showPlayIcon = false,
  showResumeIcon = false
}) => {
  const getButton = item => {
    let text = getString('button.start.label');
    let style = 'course-button button-start';
    let icon = showPlayIcon ? /*#__PURE__*/React.createElement(PaperIcon, {
      icon: "Play"
    }) : null;

    if (item.status === COURSE.COURSE_STATUS.IN_PROGRESS) {
      text = getString('button.resume.label');
      style = 'course-button button-resume';
      icon = showResumeIcon ? /*#__PURE__*/React.createElement(PaperIcon, {
        icon: "Clock3",
        collection: "linear"
      }) : null;
    } else if (item.status === COURSE.COURSE_STATUS.COMPLETED) {
      text = getString('button.complete.label');
      style = 'course-button button-complete';
      icon = showCompleteIcon ? /*#__PURE__*/React.createElement(PaperIcon, {
        className: "button-check",
        icon: "Check"
      }) : null;
    }

    return /*#__PURE__*/React.createElement(Button, {
      className: style,
      icon: icon,
      size: buttonSize,
      shape: buttonShape,
      onClick: () => window.location = item.path
    }, text);
  };

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    key: item.key,
    className: "carousel-item",
    style: {
      backgroundImage: `url("${item.thumbnail.url}")`
    }
  }, getButton(item)), /*#__PURE__*/React.createElement(Typography.Paragraph, {
    ellipsis: {
      rows: 2
    },
    className: "course-name"
  }, item.title));
};

export default CourseCarouseItem;
//# sourceMappingURL=CourseCarouseItem.js.map